import PurchaseTrainingLegalText from './PurchaseTrainingLegalText.vue';

export default PurchaseTrainingLegalText;
